import { render, staticRenderFns } from "./warehouse.vue?vue&type=template&id=67248bdf&scoped=true&"
import script from "./warehouse.vue?vue&type=script&lang=ts&"
export * from "./warehouse.vue?vue&type=script&lang=ts&"
import style0 from "./warehouse.vue?vue&type=style&index=0&id=67248bdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67248bdf",
  null
  
)

export default component.exports